<script setup lang="ts">
import { getCurrentInstance, onMounted, onUnmounted, ref } from 'vue';
import { BpmnEmitOptions } from '@/modules/low-code/process/services/BpmnService';
import { useLocalization } from '@/plugins/localization';
import { FrontActionModal } from '@/components/common/dynamic-grid/helpers/GridEnums';
import IdeoModal from '@/components/ideo/modal/IdeoModal.vue';
import { Form, FormType } from '@/helpers/Form';
import ModulesService from '@/modules/low-code/services/ModulesService';

const emit = defineEmits(["reload"]);

const modal = ref<InstanceType<typeof IdeoModal> | null>(null);

const form: FormType<any> = Form.create<any>({});

const action = Form.create<BpmnEmitOptions>({
    id: '',
    licence: '',
    actionName: '',
    buttonId: '',
});

const proxy = (getCurrentInstance()?.proxy as any) ?? null;
const { $t } = useLocalization();

async function unBlockDocument(): Promise<void>
{
    try
    {
        form.wait();

        await ModulesService.unBlockDocument(action.licence, action.id);
        proxy?.$alert.success($t('[[[Dokument został odblokowany.]]]'));

        setTimeout(() =>
        {
            emit('reload');
            proxy?.$events.$emit('refetchActions');
        }, 500);
    }
    catch (ex)
    {
        proxy?.$alert.error($t('[[[Wystąpił błąd podczas odblokowywania dokumentu.]]]'));
    }
    finally
    {
        form.continue();
    }
}

onMounted(() =>
{
    proxy?.$events.$on(FrontActionModal.UnblockDocumentModal, (payload: BpmnEmitOptions) =>
    {
        action.withData(payload);
        void unBlockDocument();
    });
});

onUnmounted(() =>
{
    proxy?.$events.$off(FrontActionModal.UnblockDocumentModal);
});
</script>

<template>
    <IdeoModal ref="modal" centered>
        <template #default>
        </template>
    </IdeoModal>
</template>

